import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useAuth} from '../../auth'
import {useParams} from 'react-router-dom'
import {getSingleContent, getlocationData, getSingleContentTimeSpend} from '../core/_requests'
import {toast} from 'react-toastify'
import {Spinner} from '../../widgets/components/General/Spinner'
import StatisticsWidgetPerformanceView from '../components/StatisticsWigetPerformanceView'
import LocationTable from '../components/LocationTable'
import StatisticsWidgetPerformanceViewTimeSpend from '../components/StatisticsWidgetPerformanceViewTimeSpend'

function MainFilePerformanceView() {
  const {formatMessage} = useIntl()
  const [singleContentLoading, setSingleContentLoading] = useState(false)
  const [singleContentTimeSpendLoading, setSingleContentTimeSpendLoading] = useState(false)
  const [singleContentData, setSingleContentData] = useState<any>()
  const [singleContentTimeSpendData, setSingleContentTimeSpendData] = useState<any>()
  const [locationLoading, setLocationLoading] = useState(false)
  const [locationCityData, setLocationCityData] = useState<any>([])
  const [locationCountryData, setLocationCountryData] = useState<any>([])
  const {companyId} = useAuth()
  const {contentId} = useParams()

  const getSingleContentById = async () => {
    try {
      setSingleContentLoading(true)
      if (companyId && contentId) {
        const {
          data: {data, success, errors},
        } = await getSingleContent(companyId, contentId)
        if (success) {
          setSingleContentData(data)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setSingleContentLoading(false)
    }
  }

  const getSingleContentByTimeSpend = async () => {
    try {
      setSingleContentTimeSpendLoading(true)
      if (companyId && contentId) {
        const {
          data: {data, success, errors},
        } = await getSingleContentTimeSpend(companyId, contentId)
        if (success) {
          setSingleContentTimeSpendData(data?.last7daysCount)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setSingleContentTimeSpendLoading(false)
    }
  }

  useEffect(() => {
    getSingleContentById()
    getSingleContentByTimeSpend()
  }, [companyId, contentId]) // eslint-disable-line react-hooks/exhaustive-deps

  const formatTime = (seconds: any) => {
    if (seconds >= 60) {
      const minutes = Math.floor(seconds / 60)
      const remainingSeconds = seconds % 60
      return `${minutes}${formatMessage({id: 'min'})} ${remainingSeconds}${formatMessage({
        id: 'sec',
      })}`
    } else {
      return `${seconds}${formatMessage({id: 'sec'})}`
    }
  }

  enum location {
    LOCATION_CITY = 'city',
    LOCATION_COUNTRY = 'country',
  }

  const getLocationCityDataByContent = async () => {
    try {
      setLocationLoading(true)
      if (companyId && contentId) {
        const {
          data: {data, success, errors},
        } = await getlocationData(companyId, contentId, location.LOCATION_CITY)
        if (success) {
          setLocationCityData(data?.locationData)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLocationLoading(false)
    }
  }

  const getLocationCountryDataByContent = async () => {
    try {
      setLocationLoading(true)
      if (companyId && contentId) {
        const {
          data: {data, success, errors},
        } = await getlocationData(companyId, contentId, location.LOCATION_COUNTRY)
        if (success) {
          setLocationCountryData(data?.locationData)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLocationLoading(false)
    }
  }

  useEffect(() => {
    getLocationCityDataByContent()
    getLocationCountryDataByContent()
  }, [companyId, contentId]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {singleContentLoading && singleContentTimeSpendLoading && locationLoading ? <Spinner /> : ''}
      <div className='file-performance-wrapper'>
        <div className='first-section-wrapper'>
          <div className='bg-white p-4 border border-muted border-1 rounded-2'>
            <div className='d-flex gap-2 align-items-end'>
              <h1 className='font-size-24 lh-base text-dark'>
                {singleContentData?.visitsData?.length} {formatMessage({id: 'Visitors'})}
              </h1>
              {/* <p className='font-size-12 text-dark lh-base'>{formatMessage({id: 'Visit'})}</p> */}
            </div>

            <h6 className='font-size-14 text-dark mb-0 lh-base fw-medium'>
              {formatMessage({id: 'Core Metrics'})}
            </h6>
          </div>
          <div className='bg-white p-4 border border-muted border-1 rounded-2'>
            <div className='d-flex flex-row align-items-center gap-2'>
              {/* <div>
                {singleContentData &&
                  singleContentData?.content?.file?.name.split('.').pop() === 'pdf' && (
                    <img
                      height={24}
                      width={24}
                      alt={formatMessage({id: 'pdf'})}
                      src={toAbsoluteUrl('/media/svg/files/pdf.svg')}
                    />
                  )}
                {singleContentData &&
                  (singleContentData?.content?.file?.name.split('.').pop() === 'docx' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'doc') && (
                    <img
                      height={24}
                      width={24}
                      alt={formatMessage({id: 'docx'})}
                      src={toAbsoluteUrl('/media/svg/files/doc-file.svg')}
                    />
                  )}
                {singleContentData &&
                  (singleContentData?.content?.file?.name.split('.').pop() === 'pptx' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'ppt') && (
                    <img
                      height={24}
                      width={24}
                      alt={formatMessage({id: 'pptx'})}
                      src={toAbsoluteUrl('/media/svg/files/pptx.svg')}
                    />
                  )}
                {singleContentData &&
                  (singleContentData?.content?.file?.name.split('.').pop() === 'jpg' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'png' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'jpeg') && (
                    <img
                      height={24}
                      width={24}
                      alt={formatMessage({id: 'blank'})}
                      src={toAbsoluteUrl('/media/svg/files/blank-image-single.svg')}
                    />
                  )}
                {singleContentData &&
                  !(
                    singleContentData?.content?.file?.name.split('.').pop() === 'pdf' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'docx' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'doc' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'pptx' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'ppt' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'jpg' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'png' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'jpeg'
                  ) && (
                    <img
                      height={24}
                      width={24}
                      alt={formatMessage({id: 'blank'})}
                      src={toAbsoluteUrl('/media/svg/files/blank-image-single.svg')}
                    />
                  )}
              </div> */}
              <div className='d-flex gap-2 align-items-end'>
                <h1 className='font-size-24 lh-base text-dark'>
                  {singleContentData?.totalTimeSpendSum
                    ? formatTime(singleContentData?.totalTimeSpendSum)
                    : '-'}
                </h1>
                {/* <p className='font-size-12 text-dark lh-base'>
                  {formatMessage({id: 'visits'})}: {singleContentData?.visitsData?.length}
                </p> */}
              </div>
            </div>

            <h6 className='font-size-14 text-dark mb-0 lh-base fw-medium'>
              {formatMessage({id: 'Total Time Spend'})}
            </h6>
          </div>
        </div>

        <div className='second-section-wrapper'>
          <h5 className='second-section-heading font-size-16 font-weight-500 font-weight-md-600 mb-5 dark_text_color'>
            {formatMessage({id: 'Comparative stats'})}
          </h5>
          <div className='performance-grid-wrapper'>
            <div className='bg-white border border-muted border-2 p-6 rounded-2'>
              <p className='font-size-13 font-weight-500 font-weight-md-600 mb-2 mb-md-5 text-dark'>
                {formatMessage({id: 'Total Visit per Day'})}
              </p>
              {singleContentData && (
                <StatisticsWidgetPerformanceView
                  statisticsData={singleContentData?.last7daysCount}
                />
              )}
            </div>
            <div className='bg-white border border-muted border-2 p-6 rounded-2'>
              <p className='font-size-13 font-weight-500 font-weight-md-600 mb-2 mb-md-5 dark_text_color'>
                {formatMessage({id: 'Total Time Spend'})}
              </p>
              {singleContentTimeSpendData && (
                <StatisticsWidgetPerformanceViewTimeSpend
                  statisticsData={singleContentTimeSpendData}
                />
              )}
              {/* <div className='text-center mt-3 font-size-12 font-size-md-13 font-weight-500'>
                {formatMessage({ id: 'Version 2' })}
              </div> */}
            </div>
          </div>
        </div>
        {/* <div className='third-section-wrapper'>
          <h5 className='third-section-heading font-size-13 font-size-md-16 font-weight-500 font-weight-md-600 mb-5'>
            {formatMessage({id: 'Visit Map'})}
          </h5>
          <iframe
            title='Google Maps'
            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2773477.758501755!2d-123.52129738452246!3d47.246426541382135!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5485e5ffe7c3b0f9%3A0x944278686c5ff3ba!2sWashington%2C%20USA!5e0!3m2!1sen!2sin!4v1686310939844!5m2!1sen!2sin'
            width='100%'
            height='100%'
            loading='lazy'
          ></iframe>
        </div> */}

        <LocationTable
          locationCityData={locationCityData}
          locationCountryData={locationCountryData}
          locationLoading={locationLoading}
        />
      </div>
    </>
  )
}

export default MainFilePerformanceView
